import { STATUS_CODE } from '@/constants';
import { loadPearConfig } from '@/libs/pearConfig';

const configs = ref({ code: -1 });

const pearConfigId = 10000001690;

const usePearConfig = () => {
  onMounted(() => {
    if (configs.value.code !== STATUS_CODE.SUCCESS) {
      fetchPearConfig();
    }
  });

  const fetchPearConfig = async () => {
    const res = await loadPearConfig(pearConfigId);
    if (res?.config?.code === STATUS_CODE.SUCCESS) {
      configs.value = res.config;
    }
    return res;
  };
  return { fetchPearConfig, configs };
};

export default usePearConfig;
